<template>
  <div class="full-height">
    <div v-if="clientPortal.portal == '3'" class="full-height">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6" md="1" class="py-0">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span v-if="clientPortal.portal == 0">V2</span>
                      <span v-if="clientPortal.portal == 1">V3</span>
                      <span v-if="clientPortal.portal == 2">V4</span>
                      <span v-if="clientPortal.portal == 3">V5</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>Version</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="6" md="2" class="py-0">
              <v-list two-line>
                <v-list-item
                  :disabled="!isGrantedUser()"
                  @click="portalPresentationModelDialog = true"
                >
                  <v-list-item-icon class="dense-list-item-icon">
                    <v-icon v-if="clientPortal.isBuiltin"
                      >mdi-checkbox-marked
                    </v-icon>
                    <v-icon v-else> mdi-checkbox-blank-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span v-if="clientPortal.isBuiltin">
                        {{ clientPortal.portalOptions.name }}
                      </span>
                      <span v-else>NA</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>Template</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6" md="2" class="py-0">
              <v-list two-line>
                <v-list-item
                  :disabled="!isGrantedUser()"
                  @click="portalPresentationModelDialog = true"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <span>{{ clientPortal.portalName }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>Modèle</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6" md="2" class="py-0">
              <v-list>
                <v-list-item
                  :disabled="!isGrantedUser()"
                  @click="portalPresentationModelDialog = true"
                >
                  <v-list-item-icon class="dense-list-item-icon">
                    <v-icon v-if="clientPortal.isInherit"
                      >mdi-checkbox-marked
                    </v-icon>
                    <v-icon v-else> mdi-checkbox-blank-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Héritage</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="6" md="2" class="py-0">
              <v-list two-line>
                <v-list-item
                  :disabled="!isGrantedUser()"
                  @click="portalConfigurationMeteoDialog = true"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        clientPortal.portalConfiguration.weather_city != ""
                          ? clientPortal.portalConfiguration.weather_city
                          : "-"
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle>Ville météo</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6" md="3" class="py-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list two-line>
                    <v-list-item
                      :disabled="!isGrantedUser()"
                      @click="portalConfigurationWelcomeDialog = true"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ welcomeText }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >Welcome URL
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </template>
                <span>{{ welcomeSubText }} </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
        <edit-portal-configuration-welcome-form
          v-if="clientPortal.portal == '3' && portalConfigurationWelcomeDialog"
          :isInherit="clientPortal.isInherit"
          :portalOptionsId="clientPortal.portalOptionsId"
          :isBuiltIn="clientPortal.isBuiltin"
          :portalConfiguration="clientPortal.portalConfiguration"
          :portalConfigurationModel="clientPortal.portalConfigurationModel"
          :updatePortalConfiguration="updatePortalConfigurationSparse"
          :id="String(clientPortal.id)"
          :group="clientPortal.group"
          :partner="clientPortal.partner"
          :portalPresentationOtherDialog.sync="portalConfigurationWelcomeDialog"
          :rules="rules"
        ></edit-portal-configuration-welcome-form>
        <edit-portal-configuration-meteo-form
          v-if="clientPortal.portal == '3' && portalConfigurationMeteoDialog"
          :isInherit="clientPortal.isInherit"
          :portalOptionsId="clientPortal.portalOptionsId"
          :isBuiltIn="clientPortal.isBuiltin"
          :portalConfiguration="clientPortal.portalConfiguration"
          :portalConfigurationModel="clientPortal.portalConfigurationModel"
          :updatePortalConfiguration="updatePortalConfigurationSparse"
          :id="String(clientPortal.id)"
          :group="clientPortal.group"
          :partner="clientPortal.partner"
          :portalPresentationOtherDialog.sync="portalConfigurationMeteoDialog"
          :rules="rules"
        ></edit-portal-configuration-meteo-form>
      </v-card>
      <v-card class="mt-2 pa-0" style="height: calc(100% - 112px)">
        <v-card-text class="pa-0 full-height">
          <v-container fluid class="full-height pa-0">
            <v-row class="full-height" no-gutters>
              <v-col cols="12" md="8" class="border-right relative">
                <div class="text-center full-height">
                  <iframe
                    :src="previewUrl"
                    style="
                      width: 100%;
                      max-width: 400px;
                      height: calc(100% - 16px);
                      overflow: auto;
                    "
                    class="mt-2"
                    v-if="portalHasNas && clientPortal.portal === 3"
                  />
                  <div v-else>
                    Le portail n'a pas de NAS actif et/ou n'est pas en V5
                  </div>
                </div>
                <preview-portal-fab
                  v-if="portalHasNas && clientPortal.portal === 3"
                  :nas="clientPortal.firstNas"
                ></preview-portal-fab>
              </v-col>
              <v-col cols="12" md="4" class="pl-0">
                <v-card class="pa-0" flat>
                  <v-card-title>Bandeau</v-card-title>
                  <v-card-subtitle>{{ bannerSubText }}</v-card-subtitle>
                  <v-card-text>
                    <client-portal-banner-footer
                      :client-portal="clientPortal"
                      type="banner"
                      v-on:refresh-preview="reloadPreview"
                    ></client-portal-banner-footer>
                  </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-card class="pa-0" flat>
                  <v-card-title>Footer</v-card-title>
                  <v-card-subtitle>{{ footerSubText }}</v-card-subtitle>
                  <v-card-text>
                    <client-portal-banner-footer
                      :client-portal="clientPortal"
                      type="footer"
                      v-on:refresh-preview="reloadPreview"
                    ></client-portal-banner-footer>
                  </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-card class="pa-0" flat>
                  <v-card-title>Fond</v-card-title>
                  <v-card-subtitle>{{ backgroundSubText }}</v-card-subtitle>
                  <v-card-text>
                    <client-portal-background
                      :client-portal="clientPortal"
                      v-on:refresh-preview="reloadPreview"
                    ></client-portal-background>
                  </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-card
                  :loading="colorsLoading"
                  flat
                  class="pb-2"
                  style="height: calc(100% - 280px)"
                >
                  <v-card-title>
                    Couleurs
                    <v-spacer></v-spacer>
                    <v-switch
                      v-if="clientPortal.isInherit || clientPortal.isBuiltIn"
                      label="Héritage groupe"
                      inset
                      dense
                      hide-details
                      class="ma-0 pa-0 mr-3"
                      v-model="inheritGroupColors"
                    ></v-switch>
                    <div class="ml-3">
                      <v-btn
                        v-if="isGrantedUser() && !editMode"
                        icon
                        @click="editMode = true"
                        :disabled="
                          (clientPortal.inheritColors && inheritGroupColors) ||
                          !clientPortal.portalConfigurationModel.has_color
                        "
                        small
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="editMode"
                        @click="cancelThemeChanges"
                        icon
                        small
                      >
                        <v-icon>mdi-cancel</v-icon>
                      </v-btn>
                    </div>
                  </v-card-title>
                  <v-card-subtitle
                    v-if="
                      clientPortal.isInherit &&
                      (clientPortal.portalConfiguration.theme !=
                        clientPortal.group.portalConfiguration.theme ||
                        clientPortal.portalConfiguration.colors.primary !=
                          clientPortal.group.portalConfiguration.colors
                            .primary ||
                        clientPortal.portalConfiguration.colors.secondary !=
                          clientPortal.group.portalConfiguration.colors
                            .secondary)
                    "
                  >
                    Couleurs du portail en surcharge
                  </v-card-subtitle>
                  <v-card-text class="py-0" style="height: calc(100% - 68px)">
                    <edit-portal-presentation-theme-form
                      v-if="clientPortal.portal == '3'"
                      :isInherit="clientPortal.isInherit"
                      :isBuiltIn="clientPortal.isBuiltin"
                      :portalConfiguration.sync="
                        clientPortal.portalConfiguration
                      "
                      :portalConfigurationModel="
                        clientPortal.portalConfigurationModel
                      "
                      :id="String(clientPortal.id)"
                      :group="clientPortal.group"
                      :partner="clientPortal.partner"
                      :portalPresentationThemeDialog.sync="
                        portalPresentationThemeDialog
                      "
                      :rules="rules"
                      :editMode="editMode"
                      ref="editTheme"
                      @open:palette="paletteDrawer = true"
                      @save:colors="saveTheme"
                      @cancel:colors="cancelThemeChanges"
                    ></edit-portal-presentation-theme-form>
                  </v-card-text>
                  <palette-chooser
                    :disabled="!editMode"
                    :portalColors.sync="clientPortal.portalConfiguration.colors"
                    :banner="clientPortal.bannerPath"
                    :background="clientPortal.backgroundPath"
                    :open.sync="paletteDrawer"
                  ></palette-chooser>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <edit-portal-presentation-model-form
        v-if="clientPortal.portal == '3' && portalPresentationModelDialog"
        :isInherit="clientPortal.isInherit"
        :isBuiltIn="clientPortal.isBuiltin"
        :portalConfiguration="clientPortal.portalConfiguration"
        :portalConfigurationModel="clientPortal.portalConfigurationModel"
        :updatePortalConfiguration="updatePortalConfigurationModel"
        :id="String(clientPortal.id)"
        :group="clientPortal.group"
        :partner="clientPortal.partner"
        :portalPresentationModelDialog.sync="portalPresentationModelDialog"
        :rules="rules"
        :portalOptionsId="clientPortal.portalOptionsId"
      ></edit-portal-presentation-model-form>
    </div>
    <div v-else>
      <v-alert type="warning">
        Il faut migrer le portail pour pouvoir le configurer.
      </v-alert>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  computed,
  toRefs,
  onMounted,
  ref,
  watch,
} from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";
import EditPortalConfigurationWelcomeForm from "@/components/PortalConfiguration/EditPortalConfigurationWelcomeForm";
import EditPortalConfigurationMeteoForm from "@/components/PortalConfiguration/EditPortalConfigurationMeteoForm";
import EditPortalPresentationThemeForm from "@/components/PortalConfiguration/EditPortalPresentationThemeForm";
import EditPortalPresentationModelForm from "@/components/PortalConfiguration/EditPortalPresentationModelForm";
import ClientPortalBannerFooter from "@/components/ClientPortal/ClientPortalBannerFooter";
import ClientPortalBackground from "@/components/ClientPortal/ClientPortalBackground";
import PaletteChooser from "@/components/ClientPortal/PaletteChooser.vue";
import PreviewPortalFab from "@/components/ClientPortal/PreviewPortalFab";
import { useIframePreview } from "@/composables/iframe-preview";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    EditPortalPresentationThemeForm,
    ClientPortalBannerFooter,
    ClientPortalBackground,
    PreviewPortalFab,
    PaletteChooser,
    EditPortalConfigurationWelcomeForm,
    EditPortalConfigurationMeteoForm,
    EditPortalPresentationModelForm,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const {
      data,
      updatePortalConfiguration,
      updatePortalConfigurationModel,
      updatePortalConfigurationSparse,
    } = useClientPortal();
    const { reloadPreview } = useIframePreview();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const colorsLoading = ref(false);
    const editMode = ref(false);
    const editTheme = ref(null);
    let originalColors = {
      primary: "",
      secondary: "",
      theme: "",
      background: "",
      opacity: "",
    };
    const baseUrl = config.VUE_APP_API_PUBLIC;
    const paletteDrawer = ref(false);
    const inheritGroupColors = ref(props.clientPortal.inheritColors);
    const colorFormData = ref({});

    /* Cycle de vie */
    onMounted(() => {
      // Impossible de faire un deep clone via les méthodes connues. La copie est toujours faite par référence no matter what et l'objet originalColors était mis à jour avec les nouvelles valeurs sans qu'on lui ait demandé
      originalColors.primary = props.clientPortal.portalConfiguration.colors
        ? props.clientPortal.portalConfiguration.colors.primary
        : null;
      originalColors.secondary = props.clientPortal.portalConfiguration.colors
        ? props.clientPortal.portalConfiguration.colors.secondary
        : null;
      originalColors.background = props.clientPortal.portalConfiguration.colors
        ? props.clientPortal.portalConfiguration.colors.background
        : null;
      originalColors.opacity = props.clientPortal.portalConfiguration.colors
        ? props.clientPortal.portalConfiguration.colors.opacity
        : null;
      originalColors.theme = props.clientPortal.portalConfiguration.colors
        ? props.clientPortal.portalConfiguration.theme
        : null;
    });

    /* Computed */
    const portalHasNas = computed(function () {
      if (props.clientPortal && props.clientPortal.firstNas) {
        return true;
      } else {
        return false;
      }
    });

    const welcomeText = computed(function () {
      let result = "";

      if (props.clientPortal) {
        result =
          props.clientPortal.portalConfiguration.welcome_url !== ""
            ? props.clientPortal.portalConfiguration.welcome_url
            : "-";
        if (props.clientPortal.isInherit) {
          if (
            props.clientPortal.portalConfiguration.welcome_url === "" ||
            props.clientPortal.portalConfiguration.welcome_url ===
              props.clientPortal.group.portalConfiguration.welcome_url
          ) {
            result = props.clientPortal.group.portalConfiguration.welcome_url;
          } else if (
            props.clientPortal.portalConfiguration.welcome_url !==
            props.clientPortal.group.portalConfiguration.welcome_url
          ) {
            result = props.clientPortal.portalConfiguration.welcome_url;
          }
        }
      }
      return result;
    });

    const welcomeSubText = computed(function () {
      let result = "";

      if (props.clientPortal) {
        if (props.clientPortal.isInherit) {
          if (
            props.clientPortal.portalConfiguration.welcome_url === "" ||
            props.clientPortal.portalConfiguration.welcome_url ===
              props.clientPortal.group.portalConfiguration.welcome_url
          ) {
            result = "Héritage";
          } else if (
            props.clientPortal.portalConfiguration.welcome_url !==
            props.clientPortal.group.portalConfiguration.welcome_url
          ) {
            result = "Surcharge";
          }
        }
      }

      return result;
    });

    const bannerSubText = computed(function () {
      let result = "";

      if (props.clientPortal) {
        if (props.clientPortal.isInherit) {
          if (
            props.clientPortal.bannerPath.indexOf("/banner") <= -1 ||
            props.clientPortal.bannerPath == props.clientPortal.group.bannerPath
          ) {
            result = "Le bandeau hérite actuellement du groupe";
          } else if (
            props.clientPortal.bannerPath != props.clientPortal.group.bannerPath
          ) {
            result = "Le bandeau est actuellement en surcharge du groupe";
          }
        }
      }

      return result;
    });
    const footerSubText = computed(function () {
      let result = "";

      if (props.clientPortal) {
        if (props.clientPortal.isInherit) {
          if (
            props.clientPortal.footerPath.indexOf("/footer") <= -1 ||
            props.clientPortal.footerPath ===
              props.clientPortal.group.footerPath
          ) {
            result = "Le footer hérite actuellement du groupe";
          } else if (
            props.clientPortal.footerPath !==
            props.clientPortal.group.footerPath
          ) {
            result = "Le footer est actuellement en surcharge du groupe";
          }
        }
      }

      return result;
    });
    const backgroundSubText = computed(function () {
      let result = "";

      if (props.clientPortal.isInherit) {
        if (
          props.clientPortal.backgroundPath.indexOf("/background") <= -1 ||
          props.clientPortal.backgroundPath ==
            props.clientPortal.group.backgroundPath
        ) {
          result = "Le fond hérite actuellement du groupe";
        } else if (
          props.clientPortal.backgroundPath !=
          props.clientPortal.group.backgroundPath
        ) {
          result = "Le fond est actuellement en surcharge du groupe";
        }
      }

      return result;
    });
    const previewUrl = computed(function () {
      let value = "";

      if (props.clientPortal && props.clientPortal.firstNas) {
        value = `${baseUrl}login-url.php?id=${props.clientPortal.firstNas.nasIdentifier}`;
      }

      return value;
    });

    const applyGroupColors = function () {
      props.clientPortal.portalConfiguration.colors =
        props.clientPortal.group.portalConfiguration.colors;
      props.clientPortal.portalConfiguration.theme =
        props.clientPortal.group.portalConfiguration.theme;
      saveTheme();
    };
    const saveTheme = async function () {
      editMode.value = false;
      colorsLoading.value = true;
      colorFormData.value = {
        colors: props.clientPortal.portalConfiguration.colors,
        theme: props.clientPortal.portalConfiguration.theme,
      };
      await updatePortalConfigurationSparse(
        String(props.clientPortal.id),
        colorFormData.value
      );
      colorsLoading.value = false;
      if (props.clientPortal.portalConfiguration.colors) {
        originalColors.primary =
          props.clientPortal.portalConfiguration.colors.primary;
        originalColors.secondary =
          props.clientPortal.portalConfiguration.colors.secondary;
        originalColors.background =
          props.clientPortal.portalConfiguration.colors.background;

        originalColors.opacity =
          props.clientPortal.portalConfiguration.colors.opacity;
        originalColors.theme = props.clientPortal.portalConfiguration.theme;
      }

      reloadPreview();
    };
    const cancelThemeChanges = function () {
      props.clientPortal.portalConfiguration.colors.primary =
        originalColors.primary;
      props.clientPortal.portalConfiguration.colors.secondary =
        originalColors.secondary;
      props.clientPortal.portalConfiguration.colors.background =
        originalColors.background;
      props.clientPortal.portalConfiguration.colors.opacity =
        originalColors.opacity;
      props.clientPortal.portalConfiguration.theme = originalColors.theme;
      editMode.value = false;
    };

    /* Watchers */
    watch(
      () => [
        data.portalPresentationModelDialog,
        data.portalConfigurationWelcomeDialog,
        data.portalConfigurationMeteoDialog,
      ],
      (newValues, oldValues) => {
        if (
          (!newValues[0] && oldValues[0]) ||
          (!newValues[1] && oldValues[1]) ||
          (!newValues[2] && oldValues[2])
        ) {
          reloadPreview();
        }
      }
    );
    watch(
      () => inheritGroupColors.value,
      async (newValue, oldValue) => {
        if (newValue && !oldValue) {
          // si on active l'héritage couleur du groupe, on supprime le champ colors du portalConfiguration
          const tempPortalConfiguration = JSON.parse(
            JSON.stringify(props.clientPortal.portalConfiguration)
          );
          delete tempPortalConfiguration.colors;
          colorsLoading.value = true;
          colorFormData.value = {
            colors: null,
            theme: props.clientPortal.portalConfiguration.theme,
          };
          await updatePortalConfigurationSparse(
            String(props.clientPortal.id),
            colorFormData.value
          );
          colorsLoading.value = false;
          reloadPreview();
        } else if (!newValue && oldValue) {
          // si on désactive l'héritage groupe des couleurs
          applyGroupColors();
        }
      }
    );

    return {
      portalHasNas,
      ...toRefs(data),
      bannerSubText,
      footerSubText,
      backgroundSubText,
      welcomeText,
      welcomeSubText,
      reloadPreview,
      colorsLoading,
      editMode,
      applyGroupColors,
      saveTheme,
      cancelThemeChanges,
      editTheme,
      updatePortalConfiguration,
      previewUrl,
      isGrantedUser,
      paletteDrawer,
      inheritGroupColors,
      updatePortalConfigurationModel,
      updatePortalConfigurationSparse,
    };
  },
});
</script>
<style scoped>
.dense-list-item-icon {
  margin-right: 16px;
}
</style>
